import { execa } from 'execa';

const BASE_REMOTE_REF = 'refs/remotes/';
const ORIGIN = 'origin/';

export const getDefaultBranch = async (
  writeCrashReport: (error: unknown) => void
) => {
  try {
    const { stdout } = await execa('git', [
      'symbolic-ref',
      `${BASE_REMOTE_REF}${ORIGIN}HEAD`,
    ]);

    const fullName = stdout.replace(BASE_REMOTE_REF, '');
    return fullName;
  } catch (error) {
    // This command can fail due to several user-related reasons, but all usages are recoverable
    writeCrashReport(error);
    return null;
  }
};
